// [檔案： src/js/state.js]

// 此檔案集中管理所有模組共享的狀態

// --- 核心狀態 ---
export let userId = null;
export let currentDate = new Date();
export let transactionsSubscription = null;
export let localTransactions = [];
export let currentEditingId = null;



// --- DOM 實例 ---
export let flatpickrInstance = null; // 用於 Add/Edit Modal 的日期選擇器
export let monthSelectInstance = null; // 用於月份選擇器

// --- UI 狀態 ---
export let currentThemeIsDark = false;
export let showRunningBalance = false;
// ✅ v0.0.8 修正： 用於防止月份導覽按鈕被重複綁定
export let monthNavInitialized = false; 

// --- 狀態設置函數 (Setters) ---
export const setUserId = (val) => { userId = val; };
export const setCurrentDate = (val) => { currentDate = val; };
export const setTransactionsSubscription = (val) => { 
    transactionsSubscription = val; 
};
export const setLocalTransactions = (val) => { localTransactions = val; };
export const setCurrentEditingId = (val) => { currentEditingId = val; };
export const setFlatpickrInstance = (val) => { flatpickrInstance = val; };
export const setMonthSelectInstance = (val) => { monthSelectInstance = val; };
export const setCurrentThemeIsDark = (val) => { currentThemeIsDark = val; };
export const setShowRunningBalance = (val) => { showRunningBalance = val; };
// ✅ v0.0.8 修正：
export const setMonthNavInitialized = (val) => { monthNavInitialized = val; };